import { RouteComponentProps } from '@reach/router';

export interface LessonsNavLinksData {
  to: (params: LessonsLinkParamsData) => string;
  path: string;
  regExp: RegExp;
  name: (name: string) => string;
}

export interface LessonsLinkParamsData extends RouteComponentProps {
  lessonId: string;
  collectionId: string;
  textTypeId: string;
  exemplarId: string;
  names: string[];
}

export const lessonsNavLinks: LessonsNavLinksData[] = [
  {
    to: () => '/lessons',
    path: '/lessons',
    regExp: /\/lessons/g,
    name: () => 'Find a lesson plan',
  },
  {
    to: ({ collectionId }) => `/lessons/collection/${collectionId}`,
    path: '/lessons/collection/:collectionId',
    regExp: /\/lessons\/collection\/\d+/g,
    name: name => `${name ? name : ''}`,
  },
  {
    to: ({ collectionId, exemplarId, textTypeId }) =>
      `/lessons/collection/${collectionId}/exemplarsRelated/${exemplarId}/textType/${textTypeId}`,
    path: '/lessons/collection/:collectionId/exemplarsRelated/:exemplarId/textType/:textTypeId',
    regExp: /\/lessons\/collection\/\d+\/exemplarsRelated\/\d+\/textType\/\d+/g,
    name: name => `${name ? name : ''}`,
  },
  {
    to: ({ collectionId, exemplarId, textTypeId, lessonId }) =>
      `/lessons/collection/${collectionId}/exemplarsRelated/${exemplarId}/textType/${textTypeId}/lessons/${lessonId}`,
    path: '/lessons/collection/:collectionId/exemplarsRelated/:exemplarId/textType/:textTypeId/lessons/:lessonId',
    regExp: /\/lessons\/collection\/\d+\/exemplarsRelated\/\d+\/textType\/\d+\/lessons\/\d+/g,
    name: name => `${name ? name : ''}`,
  },
];
